import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors} from "@angular/common/http";
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from "@angular/material/form-field";
import {apiKeyInterceptor} from "./domain/services/api-key/api-key.interceptor";
import {authErrorInterceptor} from "./domain/services/auth/auth-error.interceptor";
import {clientLogInterceptor} from "./domain/services/client-log/client-log.interceptor";
import {GlobalErrorHandler} from "./domain/services/client-log/global-error-handler";
import { provideNativeDateAdapter } from '@angular/material/core';

export const appConfig: ApplicationConfig = {
  providers: [
    // Todd QA round 2: every date in the admin renders as US mm/dd/yyyy.
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: 'MM/dd/yyyy' } },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([
      apiKeyInterceptor,
      authErrorInterceptor,
      clientLogInterceptor
    ])),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideNativeDateAdapter(),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        // Required fields have to be identifiable before the user presses save, not only
        // afterwards in red. Material derives "required" from the control's own validators,
        // so leaving the marker on labels every Validators.required field for free.: false
      }
    }
  ]
};
